/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import useCommercialConcreteSaleData from './hooks/useCommercialConcreteSaleData';
import useCommercialSaleRank from './hooks/useCommercialSaleRank';
import useCommercialSaleTrend from './hooks/useCommercialSaleTrend';
import useSalePlan from './hooks/useSalePlan';
import { PieEchart, BarEchartMul } from '@/components/page-echarts';
import RankListItem from '@/views/Sale/ReportAggregate/cpns/RankListItem.vue';
import CTypeTab from '@/components/CTypeTab.vue';
import PlanPart from './cpns/PlanPart.vue';
import localCache from '@/utils/localCache';
export default defineComponent({
  name: 'CommercialConcreteSalesReport',
  components: {
    PieEchart: PieEchart,
    BarEchartMul: BarEchartMul,
    RankListItem: RankListItem,
    CTypeTab: CTypeTab,
    PlanPart: PlanPart
  },
  setup: function setup() {
    var params = ref({
      date: dayjs().format('YYYY/MM/DD'),
      type: 0 //时间类型 0日数据 1周数据 2月数据
    });
    var confrimDate = function confrimDate(val) {
      params.value.date = val;
      getAggregateSaleDataAsync();
      getAggregateSaleRankAsync();
      getAggregateSaleTrendAsync();
      getConcreteSalePlanDateAsync();
      if (params.value.type === 3) {
        getAggregateSaleTrendYearAsync();
      }
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('切换类型');
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              if (val === 4) {
                params.value.date = dayjs().format('YYYY/MM/DD') + ',' + dayjs().format('YYYY/MM/DD');
              } else {
                params.value.date = dayjs().format('YYYY/MM/DD');
              }
              if (val === 3) {
                getAggregateSaleTrendYearAsync();
              }
              getAggregateSaleDataAsync();
              getAggregateSaleRankAsync();
              getAggregateSaleTrendAsync();
              getConcreteSalePlanDateAsync();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var switchClick = function switchClick() {
      if (params.value.type === 0) {
        window.location.href = "/table/shangtongSellDay.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 1) {
        window.location.href = "/table/shangtongSellWeek.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
      if (params.value.type === 2) {
        window.location.href = "/table/shangtongSellMonth.html?factoryId=".concat(localCache.getItem('factoryId'));
      }
    };
    onMounted(function () {
      getAggregateSaleDataAsync();
      getAggregateSaleRankAsync();
      getAggregateSaleTrendAsync();
      getConcreteSalePlanDateAsync();
      if (params.value.type === 3) {
        getAggregateSaleTrendYearAsync();
      }
    });
    var _useCommercialConcret = useCommercialConcreteSaleData(params),
      _useCommercialConcret2 = _slicedToArray(_useCommercialConcret, 2),
      aggregateSaleData = _useCommercialConcret2[0],
      getAggregateSaleDataAsync = _useCommercialConcret2[1];
    var _useCommercialSaleRan = useCommercialSaleRank(params),
      _useCommercialSaleRan2 = _slicedToArray(_useCommercialSaleRan, 2),
      aggregateSaleRankData = _useCommercialSaleRan2[0],
      getAggregateSaleRankAsync = _useCommercialSaleRan2[1];
    var emptyStringFormat = useEmptyStringFormat();
    var summaryData = computed(function () {
      return [{
        num: aggregateSaleData.value.totalSettleValue,
        desc: '总销量/方'
      }, {
        num: aggregateSaleData.value.totalMoney,
        desc: '总销额/万元'
      }, {
        num: aggregateSaleData.value.totalSingular,
        desc: '总单数/单'
      }, {
        num: aggregateSaleData.value.totalAveragePrice,
        desc: '总均价/元'
      }];
    });
    var _useSalePlan = useSalePlan(params),
      _useSalePlan2 = _slicedToArray(_useSalePlan, 2),
      salePlanData = _useSalePlan2[0],
      getConcreteSalePlanDateAsync = _useSalePlan2[1];
    var planTotal = computed(function () {
      return {
        num: salePlanData.value.plan_num,
        desc: '计划量/方',
        proportion: salePlanData.value.plan_num == 0 ? 100 : Math.round(aggregateSaleData.value.totalSettleValue / salePlanData.value.plan_num * 100)
      };
    });
    var tabs = ref(['销量', '金额']);
    var curTab = ref('销量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    var categoryGoodsCount = computed(function () {
      var list = [];
      var unit = '';
      if (curTab.value === '销量') {
        list = aggregateSaleData.value.settleValueList.map(function (item) {
          return {
            name: item.name,
            value: item.value
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '方';
      }
      if (curTab.value === '金额') {
        list = aggregateSaleData.value.totMoneyList.map(function (item) {
          return {
            name: item.name,
            value: item.value
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '万元';
      }
      return {
        pieData: list,
        unit: unit,
        customTooltip: true,
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '销量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u65B9</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '金额') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                       <span style=\"font-size: 12px;\">").concat(params.value, "\u4E07\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    var _useCommercialSaleTre = useCommercialSaleTrend(params),
      _useCommercialSaleTre2 = _slicedToArray(_useCommercialSaleTre, 4),
      aggregateSaleTrendData = _useCommercialSaleTre2[0],
      aggregateSaleTrendYearData = _useCommercialSaleTre2[1],
      getAggregateSaleTrendAsync = _useCommercialSaleTre2[2],
      getAggregateSaleTrendYearAsync = _useCommercialSaleTre2[3];
    // const saleTrend = computed(() => {
    //   const list = aggregateSaleTrendData.value.map((item) => {
    //     return item.tot_money
    //   })
    //   const xLabels = aggregateSaleTrendData.value.map((item) => {
    //     return item.time
    //   })
    //   return {
    //     lineData: list,
    //     xLabels,
    //     legendData: ['销售趋势'],
    //     yName: '价格（万元）'
    //   }
    // })
    var dayData = computed(function () {
      var lineData1 = aggregateSaleTrendData.value.map(function (item) {
        return item.settle_value;
      });
      var lineData2 = aggregateSaleTrendData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleTrendData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['方数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 35
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '方数' ? '方' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var dayData1 = computed(function () {
      var lineData1 = aggregateSaleTrendYearData.value.map(function (item) {
        return item.settle_value;
      });
      var lineData2 = aggregateSaleTrendYearData.value.map(function (item) {
        return item.tot_money;
      });
      var xLabels = aggregateSaleTrendYearData.value.map(function (item) {
        return item.time;
      });
      var legendData = ['方数', '金额'];
      return {
        xLabels: xLabels,
        lineData: [lineData1, lineData2],
        legendData: legendData,
        colors: ['#82A3FF', '#5AC57F', '#EEC324'],
        grid: {
          left: 55,
          top: 10,
          bottom: 55,
          right: 20
        },
        legendBottom: 2,
        customTooltip: true,
        tooptipFormatter: function tooptipFormatter(params1) {
          var res = "\n                  <div >\n                    <div class=\"flex align-center\">\n                      <span class=\"ml-2\">".concat(params1[0].axisValue, "</span>\n\n                    </div>\n                  ");
          params1.forEach(function (item) {
            res += "\n                    <div >\n                      ".concat(item.marker, "\n                      <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                      <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value).concat(item.seriesName === '方数' ? '方' : '万元', "</span>\n                    </div>\n                  ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var router = useRouter();
    var toReportDetail = function toReportDetail() {
      router.push({
        name: 'SaleReportDetail',
        params: {
          date: params.value.date,
          type: params.value.type,
          reportType: 'shangTong' //砂浆商砼砂浆
        }
      });
    };
    return {
      params: params,
      confirmType: confirmType,
      confrimDate: confrimDate,
      switchClick: switchClick,
      emptyStringFormat: emptyStringFormat,
      aggregateSaleData: aggregateSaleData,
      summaryData: summaryData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      categoryGoodsCount: categoryGoodsCount,
      aggregateSaleRankData: aggregateSaleRankData,
      dayData: dayData,
      dayData1: dayData1,
      toReportDetail: toReportDetail,
      dateRef: dateRef,
      planTotal: planTotal,
      salePlanData: salePlanData
    };
  }
});